export const MAIN = 'CONTEXT_MENU/MAIN';
export const ACTIVE = 'CONTEXT_MENU/ACTIVE';
export const BENCH = 'CONTEXT_MENU/BENCH';
export const DECK = 'CONTEXT_MENU/DECK';
export const DISCARD = 'CONTEXT_MENU/DISCARD';
export const HAND = 'CONTEXT_MENU/HAND';
export const RETREAT = 'CONTEXT_MENU/RETREAT';
export const LOG = 'CONTEXT_MENU/LOG';
